import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import MachineryDetail from "@/pages/MachineryDetail";
import MapPage from "@/pages/MapPage";
import ContractsInfo from "@/pages/ContractsInfo";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import UserDashboard from "@/pages/UserDashboard";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminMachinery from "@/pages/admin/AdminMachinery";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminContracts from "@/pages/admin/AdminContracts";
import AdminUsers from "@/pages/admin/AdminUsers";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/catalogo" element={<Catalog />} />
      <Route path="/maquinaria/:id" element={<MachineryDetail />} />
      <Route path="/mapa" element={<MapPage />} />
      <Route path="/contratos" element={<ContractsInfo />} />
      <Route path="/login" element={<Login />} />
      <Route path="/registro" element={<Register />} />
      <Route path="/panel" element={<ProtectedRoute><UserDashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><AdminLayout /></ProtectedRoute>}>
        <Route index element={<AdminDashboard />} />
        <Route path="maquinaria" element={<AdminMachinery />} />
        <Route path="cotizaciones" element={<AdminQuotes />} />
        <Route path="contratos" element={<AdminContracts />} />
        <Route path="usuarios" element={<AdminUsers />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
